import { useState, useEffect } from 'react';

const limitSmallScreen = 5;
const limitLargeScreen = 10;
const heightThreshold = 870;

export function useVariationsConfig() {
  const [limit, setLimit] = useState(limitSmallScreen);

  useEffect(() => {
    const updateLimit = () => {
      const screenHeight = window.innerHeight;
      setLimit(
        screenHeight >= heightThreshold ? limitLargeScreen : limitSmallScreen,
      );
    };

    updateLimit();
    window.addEventListener('resize', updateLimit);

    return () => {
      window.removeEventListener('resize', updateLimit);
    };
  }, []);

  return {
    limit,
  };
}
